<li tabindex="8">
    <button
        type="button"
        class="btn btn-default nlr-icon-btn"
        id="zoomToPlanToolBtn"
        [title]="getZoomToPlanTooltip()"
        (click)="zoomToPlanExtent()"
        [disabled]="zoomToPlanExtentDisabled()">
        <i class="nlrp-icon nlrp-icon-fit-to-extent"></i>
    </button>
</li>
<li tabindex="9">
    <button
        type="button"
        class="btn btn-default nlr-icon-btn"
        id="zoomToolBtn"
        [title]="getZoomTooltip()"
        (click)="toggleZoomInToExtent()"
        [ngClass]="{active : isZoomInToExtentActive(),'nlrp-suspended': isZoomInToExtentSuspended()}"
        [disabled]="zoomInToExtentDisabled()">
        <i class="nlrp-icon nlrp-icon-zoom-in"></i>
    </button>
</li>
<li tabindex="10">
    <ng-select
        class="nlr-ng-select nlr-ng-select-ribbon referenceScale"
        [clearable]="false"
        name="referenceScale"
        id="referenceScale"
        title="Select the scale"
        [placeholder]="referenceScaleFormatted"
        [items]="getReferenceScales()"
        [trackByFn]="referenceScaleTrackBy"
        [(ngModel)]="referenceScaleSearchText"
        (change)="onSelectReferenceScale($event)"
        (open)="onSelectReferenceScaleOpen()">
    </ng-select>
</li>
